import Axios from "axios";
var PriceSettingService = (function () {
    function PriceSettingService() {
    }
    PriceSettingService.prototype.getOrderList = function (params) {
        return Axios.get("supplierclientapi/priceorder/list", { params: params });
    };
    PriceSettingService.prototype.confirm = function (order_id) {
        return Axios.get("supplierclientapi/priceorder/confirm", { params: { order_id: order_id } });
    };
    PriceSettingService.prototype.delete = function (business_id) {
        return Axios.get("supplierclientapi/priceorder/del", { params: { business_id: business_id } });
    };
    PriceSettingService.prototype.detail = function (params) {
        return Axios.get("supplierclientapi/priceorder/detail", { params: params });
    };
    PriceSettingService.createInstance = function () {
        PriceSettingService.getInstance();
    };
    PriceSettingService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PriceSettingService;
}());
export default PriceSettingService;
